import React from 'react';
import { AuthCallback } from '~/components';
import paths from '~/pages/paths';

const SalesAuthCallback: React.FC = () => <AuthCallback flowKey="sales-signup" />;

export default SalesAuthCallback;
